var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80078 6.39995H20.0008M18.4008 7.19995V18.4C18.4008 19.0365 18.1479 19.6469 17.6978 20.097C17.2478 20.5471 16.6373 20.8 16.0008 20.8H8.80078C8.16426 20.8 7.55381 20.5471 7.10372 20.097C6.65364 19.6469 6.40078 19.0365 6.40078 18.4V7.19995M10.4008 6.39995V3.99995C10.4008 3.78778 10.4851 3.5843 10.6351 3.43427C10.7851 3.28424 10.9886 3.19995 11.2008 3.19995H13.6008C13.813 3.19995 14.0164 3.28424 14.1665 3.43427C14.3165 3.5843 14.4008 3.78778 14.4008 3.99995V6.39995M10.4008 10.4V16M14.4008 10.4V16",
    stroke: "#2B2B2B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/deleteIcon.49468e377b2b34006f90e4495b1186af.svg";